module.exports = __webpack_public_path__ + "img/product2.a6e9e839.png";